import APIRequest from "./APIRequest";
import routeBuilder from "./APIRouter";
import RequestHandler from './RequestHandler';
import Collection from "../utils/Collection";

class RESTManager {
  constructor (vue, options = {}) {
    this.handlers = new Collection();
    this.options = options;
    this.vue = vue;
    this.tokenPrefix = this.options.tokenPrefix;
    this.versioned = true;
    this.token = null;

    if (this.options.restSweepInterval > 0) {
      setInterval(() => {
        this.handlers = this.handlers.filter(handler => !handler._inactive);
      }, this.options.restSweepInterval * 1000);
    }
  }

  get api () {
    return routeBuilder(this);
  }

  getAuth () {
    const token = this.token;
    if (token) return `${this.tokenPrefix} ${token}`;
    throw new Error("TOKEN_MISSING");
  }

  request (method, url, options = {}) {
    const apiRequest = new APIRequest(this, method, url, options);
    let handler = this.handlers.get(apiRequest.route);

    if (!handler) {
      handler = new RequestHandler(this);
      this.handlers.set(apiRequest.route, handler);
    }

    return handler.push(apiRequest);
  }

  get endpoint () {
    return this.options.http.api;
  }

  set endpoint (endpoint) {
    this.options.http.api = endpoint;
  }
}

export default RESTManager;
